import './lead_badge.less';

import { Flag as FlagIcon } from 'react-feather';
import React                from 'react';


export default function LeadBadge() {
  return (
    <div className="lead-badge">
      <div className="icon-column">
        <FlagIcon className="flag-icon"/>
      </div>
      <div className="text-column">
        <div className="label">Lead</div>
      </div>
    </div>
  );
}
